import { Box, Typography } from "@mui/material";
import Picker from 'rmc-picker'
import '../utils/picker.css'
import { useState } from "react";
import { temperatureASCII } from "./constants";
import { settingsInterface } from "../../../app/recipeCreation/createRecipe.types";

const TempraturePicker = ({ index, tempratureValue, localSetting }: { index: number, tempratureValue: number, localSetting: Array<settingsInterface> }) => {
  const [value, setValue] = useState(tempratureValue)
  const onChange = (value: any) => {
    setValue(value)
    localSetting[index].temperature = value
  }
  const valueArray = [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120]
  return (
    <Box style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      <Picker indicatorClassName="my-picker-indicator"
        selectedValue={value}
        onValueChange={onChange}
      >
        {valueArray.map((value) => (
          <Picker.Item className='my-picker-view-item' value={value}>{value}</Picker.Item>
        ))}
      </Picker>
      <Typography variant='caption3Light' sx={{ mt: '-6px' }}>{temperatureASCII}C</Typography>
    </Box>
  )
}

export default TempraturePicker